import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, Heart, Gift, EyeOff, Eye, Calendar, Radio, HeartHandshake, Smartphone } from "lucide-react";
import api from "@/lib/api";
import { useFeature } from "@/contexts/FeaturesContext";

/* ── Portofelul de Semințe (17.12) ── */


/* ── „Ce urmează" — calendarul meu (17.7) ── */
export function UpcomingCard() {
  const enabled = useFeature("client_calendar");
  const [nextSession, setNextSession] = useState(null);
  const [nextEvent, setNextEvent] = useState(null);
  useEffect(() => {
    if (!enabled) return;
    const today = new Date().toISOString().slice(0, 10);
    api.get("/me/sessions").then((r) => {
      const up = (r.data || []).filter((s) => s.session_date >= today && s.status !== "cancelled" && s.status !== "completed");
      setNextSession(up[0] || null);
    }).catch(() => {});
    api.get("/me/live").then((r) => {
      const evs = (r.data || []).filter((e) => (e.event_date || e.date || "") >= today).sort((a, b) => (a.event_date || a.date || "").localeCompare(b.event_date || b.date || ""));
      setNextEvent(evs[0] || null);
    }).catch(() => {});
  }, [enabled]);
  if (!enabled) return null;
  if (!nextSession && !nextEvent) return null;
  return (
    <div className="card-premium p-6" data-testid="upcoming-card">
      <h3 data-el="upcoming_title" className="font-serif text-lg mb-3 inline-flex items-center gap-2"><Calendar size={16} style={{ color: "var(--ct-link)" }} /> Ce urmează</h3>
      <div className="space-y-3">
        {nextSession && (
          <Link to="/cont?tab=sessions" className="flex items-center gap-3 p-3 rounded-xl hover:bg-[var(--ct-bg-soft)] transition-colors">
            <HeartHandshake size={18} style={{ color: "var(--ct-gold)" }} />
            <div><p data-el="upcoming_session_title" className="text-sm font-medium">Ședință cu Georgiana</p><p data-el="upcoming_session_meta" className="text-xs" style={{ color: "var(--ct-text-dim)" }}>{nextSession.session_date}{nextSession.session_time ? ` · ${nextSession.session_time}` : ""}</p></div>
          </Link>
        )}
        {nextEvent && (
          <Link to="/live" className="flex items-center gap-3 p-3 rounded-xl hover:bg-[var(--ct-bg-soft)] transition-colors">
            <Radio size={18} style={{ color: "var(--ct-gold)" }} />
            <div><p data-el="upcoming_event_title" className="text-sm font-medium">{nextEvent.title || "Eveniment live"}</p><p data-el="upcoming_event_meta" className="text-xs" style={{ color: "var(--ct-text-dim)" }}>{nextEvent.event_date || nextEvent.date || ""}</p></div>
          </Link>
        )}
      </div>
    </div>
  );
}
